import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {corDoAvatar, formateTelefone, iniciaisDoContato, nomeDoContato} from '../mia-v3/contato-mia';
import {CAMPOS_DA_FICHA} from './leads-mia-gestor.component';

type FiltroComercial = 'todas' | 'equipe' | 'conversa' | 'teste';
interface ItemChat { tipo: 'separador' | 'mensagem'; label?: string; mensagem?: any; }
/** Fato da ficha comercial com o rótulo da tela e o trecho do lead que a Mia usou como prova. */
interface FatoDaFicha { campo: string; rotulo: string; valor: string; evidencia?: string; turnoId?: number; registradoEm?: string; }

const FASES = [
  {fase: 'INICIO', rotulo: 'Início'},
  {fase: 'SDR', rotulo: 'Conversa comercial'},
  {fase: 'CRIAR_TESTE', rotulo: 'Criando teste'},
  {fase: 'AUTENTICADO', rotulo: 'Teste criado'},
];
const ORIGENS: any = {saudacao: 'saudação', botao: 'botão do interessado', ferramenta: 'Mia', operador: 'equipe', reconciliacao: 'conta criada'};

/** Modelos que o gestor-ia aceita: a conversa SDR escolhe um fixo aqui; o composer do lead escolhe na hora, na combo. */
export const MODELOS_DA_GESTOR = [
  {id: 'claude-sonnet-5-5', rotulo: 'Sonnet 5.5', dica: 'mais rápido e barato'},
  {id: 'claude-opus-5-5', rotulo: 'Opus 5.5', dica: 'mais caprichado, o dobro do custo'},
  {id: 'gpt-6.1-sol', rotulo: 'GPT-6.1 Sol', dica: 'OpenAI, mesmo preço do Sonnet'},
  {id: 'gemini-3.8-flash', rotulo: 'Gemini 3.8 Flash', dica: 'Google, o mais barato'},
];

@Component({
  selector: 'app-comercial-mia-gestor',
  templateUrl: './comercial-mia-gestor.component.html',
  styleUrls: ['./comercial-mia-gestor.component.scss'],
})
export class ComercialMiaGestorComponent implements OnInit, OnDestroy {
  @ViewChild('corpoChat') corpoChat: ElementRef<HTMLElement>;
  readonly fases = FASES;
  atendimentos: any[] = [];
  selecionado: any = null;
  idAberto: number | null = null;
  itensChat: ItemChat[] = [];
  carregando = false;
  abrindo = false;
  salvando = false;
  erro = '';
  filtro = '';
  filtroFase: FiltroComercial = 'todas';
  fichaAberta = true;
  atualizadoEm: Date | null = null;
  motivoAdiamento = '';
  /** fato com a origem aberta (trecho do lead + mensagem destacada no chat) */
  fatoAberto: string | null = null;
  /** mensagem destacada no chat ao abrir a origem de um fato */
  mensagemDestacada: number | null = null;
  historicoAberto = false;
  /** os modelos que o gestor-ia aceita para a conversa SDR */
  readonly modelos = MODELOS_DA_GESTOR;
  modeloEscolhido: string | null = null;
  salvandoModelo = false;
  erroModelo = '';
  /** chave "Teste grátis na conversa" (gestor_ia_configuracao.oferece_teste_gratis); null = ainda não lida */
  ofereceTesteGratis: boolean | null = null;
  salvandoTeste = false;
  erroTeste = '';
  private timer: any;
  private timerDestaque: any;
  private atualizando = false;
  private detalheVersao = 0;
  private destruido = false;
  constructor(private http: HttpClient) {}
  ngOnInit() {
    this.fichaAberta = window.innerWidth >= 1280;
    this.atualize(); this.timer = setInterval(() => this.atualize(false), 15000);
    this.http.get<any>('/gestor-ia/configuracao').subscribe({
      next: configuracao => {
        this.modeloEscolhido = configuracao?.modelo || null;
        this.ofereceTesteGratis = configuracao?.ofereceTesteGratis !== false;
      },
      error: () => this.erroModelo = 'Não foi possível ler a configuração da Mia.',
    });
  }
  /** Liga/desliga o teste grátis nas conversas novas (INICIO/SDR); quem já está criando o teste termina. */
  alterneTesteGratis() {
    if (this.salvandoTeste || this.ofereceTesteGratis === null) return;
    const ofereceTesteGratis = !this.ofereceTesteGratis;
    this.salvandoTeste = true; this.erroTeste = '';
    this.http.put<any>('/gestor-ia/configuracao', {ofereceTesteGratis}).subscribe({
      next: configuracao => { this.ofereceTesteGratis = configuracao?.ofereceTesteGratis !== false; this.salvandoTeste = false; },
      error: () => { this.salvandoTeste = false; this.erroTeste = 'A troca não foi salva. Tente de novo.'; }
    });
  }
  escolhaModelo(modelo: string) {
    if (modelo === this.modeloEscolhido || this.salvandoModelo) return;
    this.salvandoModelo = true; this.erroModelo = '';
    this.http.put<any>('/gestor-ia/configuracao', {modelo}).subscribe({
      next: configuracao => { this.modeloEscolhido = configuracao?.modelo || modelo; this.salvandoModelo = false; },
      error: () => { this.salvandoModelo = false; this.erroModelo = 'A troca não foi salva. Tente de novo.'; }
    });
  }
  ngOnDestroy() { this.destruido = true; clearInterval(this.timer); clearTimeout(this.timerDestaque); this.detalheVersao++; }
  get filtrados() {
    const termo = this.filtro.trim().toLocaleLowerCase();
    return this.atendimentos.filter(a => this.passaNoFiltro(a, this.filtroFase) &&
      `${a.nome} ${a.waId} ${a.encaminhamento?.motivo || ''}`.toLocaleLowerCase().includes(termo));
  }
  quantidade(filtro: FiltroComercial): number { return this.atendimentos.filter(a => this.passaNoFiltro(a, filtro)).length; }
  private passaNoFiltro(a: any, filtro: FiltroComercial): boolean {
    if (filtro === 'equipe') return this.pedeEquipe(a);
    if (filtro === 'conversa') return a.fase === 'INICIO' || a.fase === 'SDR';
    if (filtro === 'teste') return a.fase === 'CRIAR_TESTE' || a.fase === 'AUTENTICADO';
    return true;
  }
  /** Fatos na ordem do SPIN, com os rótulos do kanban; campos novos do gestor-ia entram no fim. */
  get fatos(): FatoDaFicha[] {
    const fatos: any = this.selecionado?.ficha?.fatos || {};
    const conhecidos = CAMPOS_DA_FICHA.filter(([c]) => fatos[c]?.valor).map(([campo, rotulo]) => ({...fatos[campo], campo, rotulo}));
    const outros = Object.keys(fatos).filter(c => fatos[c]?.valor && !CAMPOS_DA_FICHA.some(([k]) => k === c))
      .map(campo => ({...fatos[campo], campo, rotulo: campo.replace(/_/g, ' ')}));
    return [...conhecidos, ...outros];
  }
  /** O trecho só aparece quando acrescenta algo ao valor (a Mia às vezes grava o próprio texto do lead). */
  temTrecho(f: FatoDaFicha): boolean {
    return !!f.evidencia && f.evidencia.trim().toLocaleLowerCase() !== String(f.valor || '').trim().toLocaleLowerCase();
  }
  /** Abre a origem do fato e rola o chat até a mensagem do lead que a Mia usou, destacando-a. */
  abraFato(f: FatoDaFicha) {
    this.fatoAberto = this.fatoAberto === f.campo ? null : f.campo;
    if (!this.fatoAberto || !f.turnoId) return;
    const bolha = this.corpoChat?.nativeElement.querySelector(`[data-turno="${Number(f.turnoId)}"]`);
    if (!bolha) return;
    bolha.scrollIntoView({block: 'center', behavior: 'smooth'});
    this.mensagemDestacada = Number(f.turnoId);
    clearTimeout(this.timerDestaque);
    this.timerDestaque = setTimeout(() => this.mensagemDestacada = null, 2400);
  }
  mensagemNoChat(f: FatoDaFicha): boolean {
    return !!f.turnoId && (this.selecionado?.mensagens || []).some((m: any) => Number(m.id) === Number(f.turnoId));
  }
  rastreieFato(_: number, f: FatoDaFicha) { return f.campo; }
  rotuloFase(fase: string): string {
    return FASES.find(f => f.fase === fase)?.rotulo || fase || '—';
  }
  indiceFase(fase: string): number { return FASES.findIndex(f => f.fase === fase); }
  rotuloOrigem(origem: string): string { return ORIGENS[origem] || origem; }
  pedeEquipe(a: any): boolean { return !!a?.encaminhamento && a.encaminhamento.status !== 'OPT_OUT'; }
  pediuParaParar(a: any): boolean { return a?.encaminhamento?.status === 'OPT_OUT'; }
  entregaIncerta(a: any): boolean { return a?.ultimaEntrega === 'ENVIO_INCERTO' || a?.ultimaEntrega === 'PROCESSANDO'; }
  nome(a: any): string { return nomeDoContato(a?.nome, a?.waId); }
  iniciais(a: any): string { return iniciaisDoContato(a?.nome, a?.waId); }
  corAvatar(a: any): string { return corDoAvatar(a?.waId || a?.atendimentoId); }
  telefone(a: any): string { return formateTelefone(a?.waId); }
  linkWhatsapp(a: any): string { return `https://wa.me/${String(a?.waId || '').replace(/\D/g, '')}`; }
  get estado(): 'desabilitada' | 'bloqueada' | 'equipe' | 'mia' {
    const controle = this.selecionado?.controle;
    if (controle?.habilitada === false) return 'desabilitada';
    if (controle?.bloqueada) return 'bloqueada';
    if (controle?.pausada) return 'equipe';
    return 'mia';
  }
  horaRelativa(data: string | Date): string {
    if (!data) return '';
    const momento = new Date(data);
    const hoje = new Date();
    const ontem = new Date();
    ontem.setDate(hoje.getDate() - 1);
    if (momento.toDateString() === hoje.toDateString()) return momento.toLocaleTimeString('pt-BR', {hour: '2-digit', minute: '2-digit'});
    if (momento.toDateString() === ontem.toDateString()) return 'Ontem';
    return momento.toLocaleDateString('pt-BR', {day: '2-digit', month: '2-digit'});
  }
  private rotuloDoDia(data: string): string {
    const dia = new Date(data);
    const hoje = new Date();
    const ontem = new Date();
    ontem.setDate(hoje.getDate() - 1);
    if (dia.toDateString() === hoje.toDateString()) return 'Hoje';
    if (dia.toDateString() === ontem.toDateString()) return 'Ontem';
    return dia.toLocaleDateString('pt-BR', {day: '2-digit', month: 'long', year: 'numeric'});
  }
  private monteItensChat(mensagens: any[]): ItemChat[] {
    const itens: ItemChat[] = [];
    let diaAnterior = '';
    for (const mensagem of mensagens || []) {
      const dia = this.rotuloDoDia(mensagem.criadoEm);
      if (dia !== diaAnterior) { itens.push({tipo: 'separador', label: dia}); diaAnterior = dia; }
      itens.push({tipo: 'mensagem', mensagem});
    }
    return itens;
  }
  rastreieAtendimento(_: number, a: any) { return a.atendimentoId; }
  rastreieItem(i: number, item: ItemChat) { return item.tipo === 'mensagem' ? item.mensagem.id : `dia:${item.label}`; }
  altereFiltro(filtro: FiltroComercial) { this.filtroFase = filtro; }
  atualize(indicar = true) {
    if (this.atualizando || this.destruido) return;
    this.atualizando = true;
    this.carregando = indicar;
    this.http.get<any[]>('/gestor-ia/comercial').subscribe({
      next: itens => {
        this.atualizando = false;
        if (this.destruido) return;
        this.erro = '';
        this.atendimentos = itens;
        this.carregando = false;
        this.atualizadoEm = new Date();
        if (this.idAberto && !this.abrindo && !this.salvando) this.abra(this.idAberto, false);
      },
      error: () => { this.atualizando = false; this.carregando = false; this.erro = 'Não foi possível atualizar os atendimentos. Tente novamente.'; }
    });
  }
  abra(id: number, indicar = true) {
    const versao = ++this.detalheVersao;
    this.idAberto = id;
    this.abrindo = indicar;
    if (indicar) { this.selecionado = null; this.itensChat = []; this.erro = ''; this.motivoAdiamento = ''; this.fatoAberto = null; this.mensagemDestacada = null; }
    this.http.get<any>(`/gestor-ia/comercial/${id}`).subscribe({
      next: item => {
        if (versao !== this.detalheVersao) return;
        const colado = indicar || this.estaNoFim();
        const novas = (item.mensagens?.length || 0) !== (this.selecionado?.mensagens?.length || 0);
        this.selecionado = item;
        this.itensChat = this.monteItensChat(item.mensagens);
        this.abrindo = false;
        if (colado && (indicar || novas)) this.roleParaOFim();
      },
      error: () => { if (versao !== this.detalheVersao) return; this.abrindo = false; this.erro = 'Não foi possível abrir esta conversa.'; }
    });
  }
  fecheConversa() { this.detalheVersao++; this.idAberto = null; this.selecionado = null; this.itensChat = []; this.abrindo = false; }
  private estaNoFim(): boolean {
    const corpo = this.corpoChat?.nativeElement;
    return !corpo || corpo.scrollHeight - corpo.scrollTop - corpo.clientHeight < 80;
  }
  private roleParaOFim() {
    setTimeout(() => { const corpo = this.corpoChat?.nativeElement; if (corpo) corpo.scrollTop = corpo.scrollHeight; });
  }
  controle(acao: 'humano' | 'devolver' | 'bloquear' | 'voltar_sdr') {
    if (!this.selecionado || this.salvando) return;
    if (acao === 'voltar_sdr' && (this.selecionado.fase !== 'CRIAR_TESTE' || !this.motivoAdiamento.trim())) return;
    if (acao === 'bloquear' && !confirm('Desativar a Mia para este contato? Ela para de responder este número e não dá para reativar por esta tela.')) return;
    const id = this.selecionado.atendimentoId;
    this.salvando = true; this.erro = '';
    this.http.post(`/gestor-ia/comercial/${id}/controle`, {acao, ...(acao === 'voltar_sdr' ? {motivo: this.motivoAdiamento.trim()} : {})}).subscribe({
      next: () => { this.salvando = false; this.motivoAdiamento = ''; if (this.selecionado?.atendimentoId === id) this.abra(id, false); },
      error: () => { this.salvando = false; this.erro = 'A mudança não foi confirmada. Atualize a conversa antes de tentar novamente.'; }
    });
  }
}
